import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

const CapacitySchedules = () => import('./CapacitySchedules.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda-v2'),
    name: 'capacity-agenda',
    component: CapacitySchedules,
    meta: {
      permissions: [...ROLES],
    },
  },
];
